<template>
  <div>
    <CheckboxItem
      title="Monday"
      @change="valueChanged"
    />
    <CheckboxItem
      class="mt-1"
      title="Tuesday"
      @change="valueChanged"
    />
    <CheckboxItem
      class="mt-1"
      title="Wednesday"
      @change="valueChanged"
    />
    <CheckboxItem
      class="mt-1"
      title="Thursday"
      @change="valueChanged"
    />
    <CheckboxItem
      class="mt-1"
      title="Friday"
      @change="valueChanged"
    />
    <CheckboxItem
      class="mt-1"
      title="Saturday"
      @change="valueChanged"
    />
    <CheckboxItem
      class="mt-1"
      title="Sunday"
      @change="valueChanged"
    />
  </div>
</template>

<script>
import CheckboxItem from '@/app/shared/components/form/checkbox/checkboxItem.vue';

export default {

  components: {
    CheckboxItem,
  },

  props: {
    label: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      days: [true, true, true, true, true, true, true],
    };
  },

  mounted() {
    this.$emit('input', this.daysTotalValue());
  },

  methods: {
    valueChanged(item) {
      this.days[this.getIndex(item.title)] = item.value;
      this.$emit('input', this.daysTotalValue());
    },

    daysTotalValue() {
      let totalSum = 0;
      let enumValue = 1;
      for (let i = 0; i <= 6; i++) {
        if (this.days[i]) {
          totalSum += enumValue;
        }
        enumValue += enumValue;
      }

      return totalSum;
    },

    getIndex(day) {
      switch (day) {
        case 'Monday':
          return 0;
          break;
        case 'Tuesday':
          return 1;
          break;
        case 'Wednesday':
          return 2;
          break;
        case 'Thursday':
          return 3;
          break;
        case 'Friday':
          return 4;
          break;
        case 'Saturday':
          return 5;
          break;
        case 'Sunday':
          return 6;
          break;
      }
    },
  },
};
</script>
